import { useLocation } from 'react-router-dom';
import path from 'path';
import config from '../config';
import FlexAlert from './FlexAlert';

const DownloadPage = () => {
  const location = useLocation();

  const downloadUrl = `${config.serverUrl}${location.pathname.replace('/download', '/api')}`;

  return (
    <FlexAlert variant="success" icon="fad fa-download">
      <h5>
        Downloading <a href={downloadUrl}>{path.basename(downloadUrl)}</a>
      </h5>
      <div>
        <a href={downloadUrl}>{downloadUrl}</a>
      </div>
    </FlexAlert>
  );
};

export default DownloadPage;
